module.exports = __webpack_public_path__ + "static/Python_Balloon-1213c0b0c2b6313e25dd1792fe406a17.png";